import { render, staticRenderFns } from "./uopload.vue?vue&type=template&id=f1b0494c&"
import script from "./uopload.vue?vue&type=script&lang=js&"
export * from "./uopload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports